// extracted by mini-css-extract-plugin
export default {"root":"timeline_root__Qz+NS","item":"timeline_item__tCGWu","itemBullet":"timeline_itemBullet__c-KS7"};